import React from 'react';
import { VotingTokenItem } from './components/VotingTokenTable/components';
import styles from './components/VotingTokenTable/styles.module.scss';

const organizationName = 'Sample DAO';

const mockVotingTokenData = {
    tokenValue: '1.2M',
    holders: '8,543',
    totalSupply: '100M',
    circulatingSupply: '85M',
    totalSupplyPercentage: '1.2%',
    circulatingSupplyPercentage: '1.4%',
    tokenName: 'Sample Token',
    tokenSymbol: 'SMPL'
};

export const blurredVotingTokenContent = (
    <div className={styles.content}>
        <div className={styles.headSection}>
            <div className={styles.textSection}>
                <h4>
                    {`Voting Token: `}
                    <span className={styles.titleLink}>
                        <span className={styles.linkText}>
                            {mockVotingTokenData.tokenName}
                            {mockVotingTokenData.tokenName ? ', ' : ''}{' '}
                        </span>
                        <span className={styles.linkText}>{mockVotingTokenData.tokenSymbol}</span>
                    </span>
                </h4>
                <h5>Last Update: 12/15/2023</h5>
            </div>
        </div>
        <div className={styles.gridSection}>
            <VotingTokenItem
                topTitle={'Tokens in Treasury'}
                topNumber={mockVotingTokenData.tokenValue}
                bottomTitle={'Token Holders'}
                bottomNumber={mockVotingTokenData.holders}
                allowCustomDisplay
            />
            <VotingTokenItem
                topTitle={'Total Supply'}
                topNumber={mockVotingTokenData.totalSupply}
                bottomTitle={'Circulating Supply'}
                bottomNumber={mockVotingTokenData.circulatingSupply}
                allowCustomDisplay
            />
            <VotingTokenItem
                topTitle={'% total supply in treasury'}
                topNumber={mockVotingTokenData.totalSupplyPercentage}
                bottomTitle={'% circulating supply in treasury'}
                bottomNumber={mockVotingTokenData.circulatingSupplyPercentage}
                allowCustomDisplay
            />
        </div>
    </div>
); 